import React, { useEffect, useState } from "react";
import IMAGES from "../../Assets/images";
import OptionButton from "Components/UI/OptionButton";
import {
  getEquipmentUsageFile,
  getEquipmentUsageFiles,
} from "Network/Core/EquipmentMaster/equipmentUsage";
import images from "../../Assets/images";
import { useApiCall } from "Hooks/useApiCall";

interface FileItemProps {
  fileId: number;
  equipmentId: number;
  region: number;
  fileName: string;
  fileCategory: string;
  fileDate: string;
  fileSize: string;
  project: any;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  canEdit?: boolean;
  canDelete?: boolean;
  canDownload?: boolean;
  canView?: boolean;
}

const FileItem: React.FC<FileItemProps> = ({
  fileId,
  equipmentId,
  fileName,
  region,
  fileCategory,
  fileDate,
  fileSize,
  project,
  onEditClick,
  onDeleteClick,
  canEdit,
  canDelete,
  canDownload,
  canView
}) => {
  const { call } = useApiCall();
  const [fileObject, setFileObject] = useState<any>(null);

  // Determine icon based on file extension
  const getFileIcon = (fileName: string) => {
    const fileExtension = fileName.split(".").pop()?.toLowerCase();

    switch (fileExtension) {
      case "pdf":
        return IMAGES.pdf_ic;
      case "jpg":
      case "jpeg":
      case "png":
        return IMAGES.img_ic;
      default:
        return IMAGES.csv_ic;
    }
  };

  const getOptions = (rowItem: any) => {
    return [
      {
        title: "Edit",
        onClick: () => {
          if (onEditClick) onEditClick();
        },
        disabled: !canEdit,
        style: {},
      },
      {
        title: "Delete",
        onClick: () => {
          if (onDeleteClick) onDeleteClick();
        },
        disabled: !canDelete,
        style: { color: "red" },
      },
    ];
  };

  const getFileObject = async () => {
    call(
      () => getEquipmentUsageFiles(equipmentId, region, project),
      (response: any) => {
        if (response) {
          const file = response?.find((file: any) => file.id === fileId);
          setFileObject(file);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  };

  useEffect(() => {
    getFileObject();
  }, []);

  const viewImageFromURL = (url: string) => {
    fetch(url).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      });
    });
  };

  const downloadImageFromURL = (url: string, downloadName?: string) => {
    fetch(url).then((response) => {
      response.blob().then((blob) => {
        let blobUrl = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = blobUrl;
        a.download = downloadName || blobUrl?.split("?")[0].split("/").slice(-1)[0];
        a.click();
        a.remove();
      });
    });
  };

  return (
    <div
      className="d-flex align-items-center p-3 border rounded shadow-sm w-100"
      style={{
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",
      }}
    >
      {/* Column 1: File Icon */}
      <div style={{ display: "flex", gap: "10px" }}>
        <div
          className="me-3"
          style={{
            flex: "0 0 40px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={getFileIcon(fileName)}
            alt="File Icon"
            style={{ height: "20px", width: "20px" }}
          />
        </div>

        {/* Column 2: File Name */}
        <div className="flex-grow-1 text-break" style={{ minWidth: "150px" }}>
          <span className="fw-semibold text-muted small d-block">
            {fileName}
          </span>
        </div>
      </div>
      {/* Column 3: File Date */}
      <div
        className="text-muted small"
        style={{ flex: "0 0 120px", textAlign: "center" }}
      >
        {fileDate}
      </div>

      {/* Column 4: File Size */}
      <div
        className="text-muted small"
        style={{ flex: "0 0 80px", textAlign: "center" }}
      >
        {fileSize}
      </div>
      <div>
        <div className="option-div">
          {canView && (<button className="btn sidebar-option-btn mr-1 p-0">
            <img
              src={images.ViewAlt}
              onClick={() => viewImageFromURL(fileObject?.fileUrl)}
            />
          </button>)}
          {canDownload && (<button className="btn sidebar-option-btn p-0">
            <img
              src={images.download}
              onClick={() => downloadImageFromURL(fileObject?.fileUrl, fileObject?.fileName)}
            />
          </button>)}
          <OptionButton options={getOptions(fileName)} />
        </div>
      </div>
    </div>
  );
};

export default FileItem;
